export const canUseDOM = typeof window !== 'undefined';
